import Communications from "../pages/communication/CommunicationMatters.js";
import StudentDesciplinaryRecords from "../pages/Descipline/StudentDesciplinaryRecords.js";
import ActiveDesciplinaryIssues from "../pages/Descipline/ActiveDesciplinaryIssues.js";
import ScheduleData from "../pages/General/ScheduleData.js";
import CreatePayment from "../pages/payment/CreatePayment.js";
import MakePayment from "../pages/payment/MakePayment.js";
import ViewPayment from "../pages/payment/ViewPayment.js";
import PersonalBasicInfo from "../pages/StudentProfile/PersonalBasicInfo.js";
import StudentAccademicHistory from "../pages/StudentProfile/StudentAccademicHistory.js";
import StudentHealthInfo from "../pages/StudentProfile/StudentHealthInfo.js";
import StudentHealthIssue from "../pages/StudentProfile/StudentHealthIssue.js";
import AcademicCalendar from "../pages/AcademicCalendar/AcademicCalendar.js";
import Attendance from "../pages/Academics/Attendance.js";
import ApplicationEnquiryExistingParent from "../pages/Application/ApplicationEnquiryExistingParent.js";
import Dashboard from "../pages/General/Dashboard.js";
import StudentTranscript from "../pages/Academics/StudentTranscript.js";
import MarkListPage from "../pages/Academics/MarkListPage.js";
import ClassRoomAttendanceReport from "../pages/Attendance/ClassRoomAttendanceReport.js";
import HomeRoomAttendanceReport from "../pages/Attendance/HomeRoomAttendanceReport.js";

export const PrivateRoutes = [
  { path: "communications", element: <Communications /> },
  {
    path: "student-desciplinary-records",
    element: <StudentDesciplinaryRecords />,
  },
  { path: "active-desciplinary-issues", element: <ActiveDesciplinaryIssues /> },
  { path: "schedule-data", element: <ScheduleData /> },
  { path: "createPayment", element: <CreatePayment /> },
  { path: "make-payment", element: <MakePayment /> },
  { path: "view-payment", element: <ViewPayment /> },
  { path: "personal-basic-info", element: <PersonalBasicInfo /> },
  { path: "student-academic-history", element: <StudentAccademicHistory /> },
  { path: "student-health-info", element: <StudentHealthInfo /> },
  { path: "health-issue-edit", element: <StudentHealthIssue /> },
  { path: "academic-calendar", element: <AcademicCalendar /> },
  { path: "attendance", element: <Attendance /> },
  { path: "student-transcript", element: <StudentTranscript /> },
  {
    path: "application-enquiry-existingparent",
    element: <ApplicationEnquiryExistingParent />,
  },
  {
    path: "dashboard",
    element: <Dashboard />,
  },
  {
    path: "mark-list",
    element: <MarkListPage />,
  },
  {
    path: "subject-attendance",
    element: <ClassRoomAttendanceReport />,
  },
  {
    path: "home-room-attendance",
    element: <HomeRoomAttendanceReport />,
  },
];
